import { render, staticRenderFns } from "./DiagnosticView.vue?vue&type=template&id=6c919895&scoped=true&"
import script from "./DiagnosticView.vue?vue&type=script&lang=js&"
export * from "./DiagnosticView.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticView.vue?vue&type=style&index=0&id=6c919895&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c919895",
  null
  
)

export default component.exports